import { Link } from 'react-router-dom'
import SEOHead from '../components/seo/SEOHead'

export default function RefundPolicy() {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-navy-900 py-16">
      <SEOHead
        title="Refund Policy — Rondanini Learn"
        description="Refund and cancellation policy for Rondanini Publishing digital education purchases and Learn Library subscriptions."
        canonicalUrl="https://learn.rondanini.com/refund-policy"
        ogType="website"
      />
      <div className="max-w-4xl mx-auto px-4 container-padding">
        <h1 className="text-4xl font-bold text-gray-900 dark:text-white mb-2">Refund policy</h1>
        <p className="text-gray-600 dark:text-gray-400 mb-8">
          Last updated: {new Date().toLocaleDateString('en-GB', { year: 'numeric', month: 'long', day: 'numeric' })}
        </p>

        <div className="bg-white dark:bg-navy-800 rounded-lg shadow-md p-8 space-y-8 text-gray-700 dark:text-gray-300">
          <p className="text-sm text-amber-800 dark:text-amber-200 bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-800 rounded-lg p-4">
            This policy is provided for transparency. Consumer rights depend on your location and how you purchased.
            If you are unsure, contact{' '}
            <a href="mailto:support@rondanini.com" className="text-gold-600 dark:text-gold-400 underline">
              support@rondanini.com
            </a>{' '}
            before completing a purchase. You may wish to obtain independent legal advice for your situation.
          </p>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">1. Digital products and access</h2>
            <p>
              Our minimanuals and related digital content are supplied electronically. Where the service has begun with
              your agreement before the end of any statutory cancellation period, you may lose the right to cancel under
              consumer regulations that apply to you. We describe access clearly before checkout (e.g. browser access via
              Learn Library vs lifetime module access).
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">2. Learn Library subscription</h2>
            <p className="mb-3">
              Subscriptions are billed by Stripe. You can cancel renewal at any time through the Stripe customer portal
              linked in your receipt or by contacting support. Cancellation stops future charges; it does not automatically
              refund the current paid period unless required by law or agreed in writing.
            </p>
            <p>
              If you believe you were charged in error or cannot access content you paid for, email{' '}
              <a href="mailto:support@rondanini.com" className="text-gold-600 dark:text-gold-400 underline">
                support@rondanini.com
              </a>{' '}
              with your account email and order reference. We will investigate and, where appropriate, offer a remedy
              (which may include access restoration, a partial refund, or a credit at our discretion).
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">3. One-off module purchases</h2>
            <p className="mb-3">
              For individual minimanual purchases, contact support if there is a technical failure that prevents access
              after payment and we cannot resolve it within a reasonable time. We do not guarantee refunds for change of
              mind once access has been granted.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">4. Chargebacks</h2>
            <p>
              Please contact us before initiating a chargeback. We will work in good faith to resolve billing issues.
              Unfounded chargebacks may result in suspension of access pending resolution.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">5. Contact</h2>
            <p>
              Rondanini Publishing Ltd —{' '}
              <a href="mailto:support@rondanini.com" className="text-gold-600 dark:text-gold-400 underline">
                support@rondanini.com
              </a>
            </p>
          </section>

          <p className="text-sm text-gray-500 dark:text-gray-400 pt-4 border-t border-gray-200 dark:border-navy-600">
            <Link to="/" className="text-gold-600 dark:text-gold-400 hover:underline">
              ← Back to home
            </Link>
          </p>
        </div>
      </div>
    </div>
  )
}
